<template>
  <div class="head">
    <div class="info">
      <h1>{{$t('service.title')}}</h1>
      <ul>
        <li>
          <p class="h">{{$t('service.pass')}}</p>
          <p class="num">99.9<span>%</span></p>
        </li>
        <li>
          <p class="h">{{$t('service.finish')}}</p>
          <p class="num">100<span>%</span></p>
        </li>
        <li>
          <p class="h">{{$t('service.count')}}</p>
          <p class="num">27,058</p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ServiceHead'
}
</script>

<style lang="less" scoped>
.head {
  background-image: url('~@/assets/image/data/header.png');
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: calc(100vh - 9.375rem);
  color: #fff;
  text-align: center;
}
h1 {
  font-size: 3.5rem;
}
ul {
  display: flex;
  justify-content: center;
  margin-top: 6rem;
  li {
    border-right: 3px solid #fff;
    padding-right: 2rem;
    padding-left: 2rem;
    &:last-child {
      border-right: none;
    }
  }
  span {
    font-size: 22px;
  }
}
.h {
  font-size: 1.375rem;
}
.num {
  font-size: 2.8rem;
}
@media (max-width: 1300px) {
  .head {
    min-height: calc(100vh - 4.375rem);
  }
}
@media (max-width: 768px) {
  .head {
    height: 70vh;
  }
  h1 {
    font-size: 26px;
  }
  ul li {
    padding: 0 1rem;
  }
  .h {
    font-size: 14px;
  }
  .num {
    font-size: 22px;
  }
}
</style>
